import type { ReactNode } from "react";

import { PageEyeBrow } from "#/components/PageEyeBrow";
import { PageHeader } from "#/components/PageHeader";
import { PageIntro } from "#/components/PageIntro";
import { PageShell } from "#/components/PageShell";
import { Skeleton } from "#/components/ui/skeleton";

import { ProfileMedalsBadges, ProfileMedalsBadgesSkeleton } from "./-profile.medals";

export function ProfilePageScaffold({
  title,
  children,
  eyebrow = "Profile",
}: {
  title: ReactNode;
  children: ReactNode;
  eyebrow?: string;
}) {
  return (
    <PageShell>
      <div className="flex w-full flex-col">
        <PageIntro align="start">
          <PageEyeBrow>{eyebrow}</PageEyeBrow>
          {title}
        </PageIntro>
        <div className="mt-8 flex flex-col gap-10">{children}</div>
      </div>
    </PageShell>
  );
}

export function ProfilePageTitleSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <Skeleton className="h-12 w-48 max-w-full" />
      <ProfileMedalsBadgesSkeleton />
    </div>
  );
}

export function ProfilePageTitle({
  displayName,
  goldMedals,
  silverMedals,
  bronzeMedals,
}: {
  displayName: string;
  goldMedals: number;
  silverMedals: number;
  bronzeMedals: number;
}) {
  return (
    <div className="flex flex-col gap-3">
      <PageHeader>{displayName}</PageHeader>
      <ProfileMedalsBadges
        goldMedals={goldMedals}
        silverMedals={silverMedals}
        bronzeMedals={bronzeMedals}
      />
    </div>
  );
}
